"use strict";

import { gsap } from "gsap";
console.log("Chemin JS fonctionnel");

/* Variables */
let deferredPrompt;
const jetonForm = document.getElementById("jetonForm");
const jetonInput = document.getElementById("jeton");
const installContainer = document.querySelector(".install");
const installButton = document.querySelector(".install__installer");
const cancelButton = document.querySelector(".install__cancel");
const participantsForm = document.querySelector('.participants');
const participantsInscription = document.querySelector('.participants__inscription');
const btnPlusTrois = document.querySelector(".participants__plus--trois");
const btnPlusQuatre = document.querySelector(".participants__plus--quatre");
const btnMoinsTrois = document.querySelector(".participants__moins--trois");
const btnMoinsQuatre = document.querySelector(".participants__moins--quatre");
const inputJoueur3 = document.querySelector(".participants__trois");
const inputJoueur4 = document.querySelector(".participants__quatre");
const imagePierre = document.querySelector('.pierre__img');
const indication = document.querySelector('.pierre__indication');
const nomPierre = document.querySelector('.pierre__nom');
const boutonPierre = document.querySelector('.pierre__btn');
const jeuSection = document.querySelector('.jeu');
const joueursList = document.querySelector('.joueurs__list');
const pieceModale = document.querySelector('.piece');
const pieceJoueur = document.querySelector('.piece__joueur');
const pieceType = document.querySelector('.piece__type');
const pieceImg = document.querySelector('.piece__img');
const pieceBtn = document.querySelector('.piece__btn');
const vainqueur = document.querySelector('.victoire__vainqueur');
const victoireModale = document.querySelector('.victoire');
const victoireCanvas = document.querySelector('.victoire__canvas');
const victoireRejouer = document.querySelector('.victoire__btn--rejouer');
const coffreModale = document.querySelector('.coffre');
const coffreDemarrer = document.querySelector('.coffre__demarrer');
const coffreContenu = document.querySelector('.coffre__contenu');
const coffreImg = document.querySelector('.coffre__img');
const premierModale = document.querySelector('.premier');
const premierNom = document.querySelector('.premier__nom');
const faveursModale = document.querySelector('.faveurs');
const faveursButtons = document.querySelectorAll('.faveurs__faveur');
const faveursList = document.querySelector('.faveurs__list');
const faveursElement = document.querySelectorAll('.faveurs__el');
const faveurBourse = document.querySelector('.faveurs__bourse');
const faveurPseudo = document.querySelector('.faveurs__pseudo');
const faveurConserver = document.querySelector('.faveurs__conserver');
const toggleParametres = document.querySelector('.parametres__toggle');
const cercleParametres = document.querySelector('.parametres__cercle');
const menuParametres = document.querySelector('.parametres__menu');
const musiqueParametres = document.querySelector('.parametres__btn--musique');
const musiqueImgParametres = document.querySelector('.parametres__img--musique');
const effetsParametres = document.querySelector('.parametres__btn--effets');
const effetsImgParametres = document.querySelector('.parametres__img--effets');
const backgroundMusic = new Audio('/tfe-app/assets/sons/background-music.mp3');
const coffreMusic = new Audio('/tfe-app/assets/sons/intro-coffre.mp3');
const victoireJingle = new Audio('/tfe-app/assets/sons/victoire-jingle.mp3');
const touchSound = new Audio('/tfe-app/assets/sons/next.mp3');
const achatSound = new Audio('/tfe-app/assets/sons/achat.mp3');
const maledictionSound = new Audio('/tfe-app/assets/sons/malediction.mp3');
const echangeSound = new Audio('/tfe-app/assets/sons/echange.mp3');
const immuniteSound = new Audio('/tfe-app/assets/sons/immunite.mp3');
const epeeSound = new Audio('/tfe-app/assets/sons/epee.mp3');
const victoireCris = new Audio('/tfe-app/assets/sons/victoire-cris.mp3');
const boutiqueSound = new Audio('/tfe-app/assets/sons/boutique.mp3');
const spinCoinSound = new Audio('/tfe-app/assets/sons/piece.mp3');
const staggerSound = new Audio('/tfe-app/assets/sons/stagger.mp3');
let pierreSound = new Audio(`/tfe-app/assets/sons/pierre-1.mp3`);
victoireJingle.volume = 0.3;
coffreMusic.volume = 0.3;
backgroundMusic.loop = true;
backgroundMusic.volume = 0.2;
const piecesParJoueur = 6;
const bourseInitiale = 0;
const faveurRetiree = 5;
let participantCount = 2;
let joueurIndex;
let timeoutPierre;
let damocles = false;
let participants = [];
let appuiLong = false;
let timerAppui;
let timerSecousse = null;
const couleurs = ['jaune', 'rouge', 'bleu', 'vert'];
const pierres = [
    { nom: "L'Émeraude", src: "/tfe-app/assets/images/emeraude.webp", couleur: "jeu--emeraude" },
    { nom: "Le Rubis", src: "/tfe-app/assets/images/rubis.webp", couleur: "jeu--rubis" },
    { nom: "Le Saphir", src: "/tfe-app/assets/images/saphir.webp", couleur: "jeu--saphir" }
];

/* Service Worker */
if (window.matchMedia('(display-mode: standalone)').matches) {
    if (installContainer) {
        installContainer.classList.add('display--none');
    }
}

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/tfe-app/assets/service-worker.js")
    .then(() => console.log("Service Worker enregistré !"))
    .catch((err) => console.log("Erreur Service Worker :", err));
}

if (installContainer && installButton && cancelButton) {
    window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault();
        deferredPrompt = event;
    });
    installButton.addEventListener("click", () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                deferredPrompt = null;
            });
            installContainer.classList.add('display--none');
        }
    });
    cancelButton.addEventListener("click", () => {
        installContainer.classList.add('display--none');
    });
}

/* Jeton Code */
if (jetonForm) {
    const jetonValide = localStorage.getItem("jetonValide");
    const jeton = localStorage.getItem("jeton");

    if (jetonValide === "true" && jeton) {
        window.location.href = "/tfe-app/jeu.html?jeton=" + encodeURIComponent(jeton);
    }

    jetonForm.addEventListener("submit", function(event) {
        event.preventDefault();

        var inputValue = jetonInput.value;
        jetonInput.setCustomValidity("");

        if (inputValue === "Galion") {
            localStorage.setItem("jetonValide", "true");
            localStorage.setItem("jeton", inputValue);

            window.location.href = "/tfe-app/jeu.html?jeton=" + encodeURIComponent(inputValue);
        } else {
            console.log("Accès refusé");
            jetonInput.setCustomValidity("Le code est incorrect.");
        }

        jetonInput.reportValidity();
    });

    jetonInput.addEventListener("input", function() {
        jetonInput.setCustomValidity("");
    });
}

/* Formulaire Participants */
if (participantsForm && btnPlusTrois && btnPlusQuatre && btnMoinsTrois && btnMoinsQuatre && inputJoueur3 && inputJoueur4) {
    btnPlusTrois.addEventListener("click", function (event) {
        touchSound.currentTime = 0;
        touchSound.play();
        event.preventDefault();
        btnPlusTrois.classList.add('display--none');
        fadeIn(inputJoueur3);
        btnPlusQuatre.classList.remove('display--none');
        participantCount++;
    });
    btnPlusQuatre.addEventListener("click", function (event) {
        touchSound.currentTime = 0;
        touchSound.play();
        event.preventDefault();
        btnPlusQuatre.classList.add('display--none');
        fadeIn(inputJoueur4);
        participantCount++;
    });
    btnMoinsTrois.addEventListener("click", function (event) {
        touchSound.currentTime = 0;
        touchSound.play();
        event.preventDefault();
        if (window.getComputedStyle(inputJoueur4).display !== "none") {
            inputJoueur4.classList.add('display--none');
            btnPlusQuatre.classList.remove('display--none');
            participantCount--;
        } else {
            inputJoueur3.classList.add('display--none');
            btnPlusQuatre.classList.add('display--none');
            btnPlusTrois.classList.remove('display--none');
            participantCount--;
        }
    });
    btnMoinsQuatre.addEventListener("click", function (event) {
        touchSound.currentTime = 0;
        touchSound.play();
        event.preventDefault();
        inputJoueur4.classList.add('display--none');
        btnPlusQuatre.classList.remove('display--none');
        participantCount--;
    });
    participantsForm.addEventListener('submit', function(event) {
        event.preventDefault();
        touchSound.currentTime = 0;
        touchSound.play();
        
        let joueur1 = document.getElementById("joueur1").value || "Joueur 1";
        let joueur2 = document.getElementById("joueur2").value || "Joueur 2";
        let joueur3 = document.getElementById("joueur3").value || "Joueur 3";
        let joueur4 = document.getElementById("joueur4").value || "Joueur 4";
        participants = [
            { nom: joueur1, pieces: piecesParJoueur, bourse: bourseInitiale, faveur: 0, maudit: false },
            { nom: joueur2, pieces: piecesParJoueur, bourse: bourseInitiale, faveur: 0, maudit: false },
            { nom: joueur3, pieces: piecesParJoueur, bourse: bourseInitiale, faveur: 0, maudit: false },
            { nom: joueur4, pieces: piecesParJoueur, bourse: bourseInitiale, faveur: 0, maudit: false }
        ];
        participants.length = Math.min(participants.length, participantCount);
        
        console.log("Début de partie :", participants);
        participantsForm.classList.add('display--none');
        afficherPremier();
        backgroundMusic.play();
    });
    document.querySelectorAll("input").forEach((input, index, inputs) => {
        input.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
    
                let nextIndex = index + 1;
    
                while (nextIndex < inputs.length) {
                    let nextInput = inputs[nextIndex];
    
                    if (nextInput && window.getComputedStyle(nextInput).display !== "none") {
                        nextInput.focus();
                        break;
                    }
                    nextIndex++;
                }
            }
        });
    });
}

/* Changer les pierres */
function changerPierre() {
    if (boutonPierre.disabled) return;

    const pierreChoisie = pierres[Math.floor(Math.random() * pierres.length)];
    arreterSecousse(boutonPierre);
    sonPierreAleatoire();

    boutonPierre.disabled = true;
    indication.classList.remove('display--none');
    nomPierre.classList.remove('display--none');
    jeuSection.classList.remove('jeu--base');
    joueursList.classList.add('display--none');

    imagePierre.src = pierreChoisie.src;
    nomPierre.textContent = pierreChoisie.nom;

    jeuSection.classList.remove('jeu--emeraude', 'jeu--rubis', 'jeu--saphir');
    jeuSection.classList.add(pierreChoisie.couleur);

    if (timeoutPierre) {
        clearTimeout(timeoutPierre);
    }

    timeoutPierre = setTimeout(() => {
        indication.classList.add('display--none');
        nomPierre.classList.add('display--none');
        jeuSection.classList.remove('jeu--emeraude', 'jeu--rubis', 'jeu--saphir');
        jeuSection.classList.add('jeu--base');
        animateStagger(joueursList);
        boutonPierre.disabled = false;
        joueursList.classList.remove('display--none');
        if(participantCount == 2){
            joueursList.classList.add('joueurs__list--duel');
        } else {
            joueursList.classList.remove('joueurs__list--duel');
        }
    }, 3000);
}

function pierreSuivante() {
    sonPierreAleatoire();
    const currentIndex = pierres.findIndex(pierre => imagePierre.src.endsWith(pierre.src));
    const nextIndex = (currentIndex + 1) % pierres.length;
    imagePierre.src = pierres[nextIndex].src;
}

function demarrerAppuiLong(e) {
    if (boutonPierre.disabled) return;
    e.preventDefault();

    timerSecousse = setTimeout(() => {
        commencerSecousse(boutonPierre);
    }, 200);

    timerAppui = setTimeout(() => {
        appuiLong = true;
        changerPierre();
    }, 1000);
}

function arreterAppuiLong(e) {
    if (boutonPierre.disabled) return;
    e.preventDefault();
    clearTimeout(timerAppui);
    clearTimeout(timerSecousse);
    arreterSecousse(boutonPierre);

    if (!appuiLong) {
        participants.forEach((joueur) => {
            if (joueur.faveur == 1) {
                achatSound.play();
                joueur.faveur = faveurRetiree;
                actualiserJoueurs();
                console.log("Pot-de-vin utilisé :", participants);
            }
        });

        pierreSuivante();
    }

    appuiLong = false;
}

if (boutonPierre) {
    boutonPierre.addEventListener('mousedown', demarrerAppuiLong);
    boutonPierre.addEventListener('mouseup', arreterAppuiLong);
    boutonPierre.addEventListener('mouseleave', () => {
        clearTimeout(timerAppui);
        clearTimeout(timerSecousse);
        arreterSecousse(boutonPierre);
    });
    boutonPierre.addEventListener('touchstart', demarrerAppuiLong, { passive: false });
    boutonPierre.addEventListener('touchend', arreterAppuiLong, { passive: false });
    boutonPierre.addEventListener('touchcancel', () => {
        clearTimeout(timerAppui);
        clearTimeout(timerSecousse);
        arreterSecousse(boutonPierre);
    });
}

/* Joueurs */
function actualiserJoueurs() {
    joueursList.innerHTML = '';

    participants.forEach((participant, index) => {
        const li = document.createElement('li');
        li.classList.add('joueurs__el');

        const button = document.createElement('button');
        button.classList.add('joueurs__btn', `joueurs__btn--${index + 1}`);

        const nomDiv = document.createElement('div');
        nomDiv.classList.add('joueurs__nom');
        nomDiv.textContent = participant.nom;

        const coffreEtFaveurImg = document.createElement('div');
        coffreEtFaveurImg.classList.add('joueurs__inventaire');

        const piecesContainerDiv = document.createElement('div');
        piecesContainerDiv.classList.add('joueurs__coffre');

        const piecesCountDiv = document.createElement('div');
        piecesCountDiv.classList.add('joueurs__coffre--count');
        piecesCountDiv.textContent = participant.pieces;

        const img = document.createElement('img');
        img.src = '/tfe-app/assets/images/coffre_icone.webp';
        img.alt = 'Un coffre maudit';
        img.classList.add('joueurs__coffre--img');

        piecesContainerDiv.appendChild(piecesCountDiv);
        piecesContainerDiv.appendChild(img);

        const faveurImg = document.createElement('img');
        faveurImg.classList.add('joueurs__faveur');
        faveurImg.classList.add('display--none');
        faveurImg.src = "/tfe-app/assets/images/damocles.webp";
        faveurImg.alt = "Faveur du joueur";

        coffreEtFaveurImg.appendChild(piecesContainerDiv);
        coffreEtFaveurImg.appendChild(faveurImg);
        button.appendChild(nomDiv);
        button.appendChild(coffreEtFaveurImg);
        li.appendChild(button);
        joueursList.appendChild(li);

        actualiserMaudit(index, participant.maudit);
        actualiserFaveurs(index, participant);
    });
}

/* Pioche Pièces */
function retirerPiece(index) {
    const joueur = participants[index];
    
    if (joueur.maudit) return;
    
    if (joueur.pieces > 0) {
        const chance = Math.floor(Math.random() * joueur.pieces) + 1;

        if (chance === 1) {
            maledictionSound.play();
            joueur.maudit = true;
            damocles = false;
            actualiserJoueurs();
            console.log(`${joueur.nom} est maudit`);
            verifierGagnant();
            pieceType.innerHTML = "la&nbsp;pièce&nbsp;<span class='piece__couleur--maudite'>Maudite</span>";
            pieceImg.src = '/tfe-app/assets/images/piece-maudite.webp';
        } else {
            joueur.pieces--;
            joueur.bourse++;
            actualiserJoueurs();
            console.log(`${joueur.nom} a pioché une pièce d'or`);
            pieceType.innerHTML = "une&nbsp;pièce&nbsp;d'<span class='piece__couleur--or'>Or</span>";
            pieceImg.src = '/tfe-app/assets/images/piece.webp';
        }

        pieceJoueur.classList.remove('jaune', 'rouge', 'bleu', 'vert');
        pieceJoueur.classList.add(couleurs[index]);
        fadeIn(pieceModale);
        pieceJoueur.textContent = joueur.nom;
        animatePieces();
    }
}

function actualiserMaudit(index, maudit = false) {
    const button = document.querySelector(`.joueurs__btn--${index + 1}`);
    const piecesCountDiv = button.querySelector('.joueurs__coffre--count');
    const joueurEl = button.closest('.joueurs__el');
    
    if (piecesCountDiv) {
        piecesCountDiv.textContent = maudit ? "Maudit(e)" : participants[index].pieces;
    }
    
    if (maudit) {
        button.disabled = true;
        joueurEl.classList.add('joueurs__el--maudit');
        joueurEl.querySelector('img').src = '/tfe-app/assets/images/piece-maudite.webp';
    } else {
        joueurEl.classList.remove('joueurs__el--maudit');
        joueurEl.querySelector('img').src = '/tfe-app/assets/images/coffre_icone.webp';
    }
}

function verifierGagnant() {
    const joueursNonMaudits = participants.filter(joueur => !joueur.maudit);

    if (joueursNonMaudits.length === 1) {
        const gagnant = joueursNonMaudits[0];
        const index = participants.indexOf(gagnant);
        console.log(`Victoire de ${gagnant.nom} !`);
        vainqueur.classList.remove('jaune', 'rouge', 'bleu', 'vert');
        vainqueur.classList.add(couleurs[index]);
        vainqueur.textContent = gagnant.nom;
        desactiverPioche();

        pieceBtn.removeEventListener('click', actionBtnPiece);
        pieceBtn.addEventListener('click', afficherVictoire, { once: true });
    }
}

function desactiverPioche() {
    const boutons = document.querySelectorAll('.joueurs__btn');
    boutons.forEach(button => {
        button.disabled = true;
    });
}

document.addEventListener('click', function (event) {
    if (event.target.closest('.joueurs__btn')) {
        const button = event.target.closest('.joueurs__btn');
        joueurIndex = parseInt(button.classList[1].split('--')[1]) - 1;
        const joueur = participants[joueurIndex];
        const IndexFav4 = participants.findIndex(p => p.faveur === 4);
        const IndexFav3 = participants.findIndex(p => p.faveur === 3);

        if(IndexFav4 !== -1){
            if (IndexFav4 === joueurIndex) {
                return;
            }

            echangeSound.play();
            participants[IndexFav4].faveur = faveurRetiree;
            const tempPieces = joueur.pieces;
            joueur.pieces = participants[IndexFav4].pieces;
            participants[IndexFav4].pieces = tempPieces;
            actualiserJoueurs();
            console.log("Échange utilisé :", participants);
        } else if(joueur.faveur == 2){
            if(IndexFav3 !== -1){
                participants[IndexFav3].faveur = faveurRetiree;
            }

            immuniteSound.play();
            joueur.faveur = faveurRetiree;
            actualiserJoueurs();
            console.log("Immunité utilisée :", participants);

            immuniteSound.addEventListener('ended', () => {
                changerPierre();
            });
        } else if(IndexFav3 !== -1){
            epeeSound.play();
            participants[IndexFav3].faveur = faveurRetiree;
            damocles = true;
            actualiserJoueurs();
            console.log("Damoclès utilisé :", participants);
            retirerPiece(joueurIndex);
        } else {
            retirerPiece(joueurIndex);
        }
    }
});

/* Modale Piece */
if(pieceBtn){
    pieceBtn.addEventListener('click', actionBtnPiece);
}

function actionBtnPiece() {
    if (damocles && !participants[joueurIndex].maudit){
        epeeSound.play();
        damocles = false;
        retirerPiece(joueurIndex);
    } else {
        afficherFaveurs(joueurIndex);
    }
}

/* Modale Victoire */
function afficherVictoire() {
    backgroundMusic.pause();
    backgroundMusic.currentTime = 0;
    victoireCris.play();
    victoireJingle.play();
    jeuSection.classList.add('display--none');
    pieceModale.classList.add('display--none');
    fadeIn(victoireModale);
}

if(victoireRejouer){
    victoireRejouer.addEventListener('click', () => {
        reset();
    });
}

function reset() {
    victoireModale.classList.add('display--none');
    fadeIn(participantsForm);
    animateStagger(participantsInscription);
    jeuSection.classList.add('display--none');
    
    document.querySelectorAll('.joueurs__btn').forEach(button => {
        button.disabled = false;
    });

    faveursButtons.forEach(element => {
        element.classList.remove('faveurs__faveur--vendu');
    });

    faveursButtons.forEach(button => {
        button.classList.remove('jaune', 'rouge', 'bleu', 'vert');
    });

    pieceBtn.addEventListener('click', actionBtnPiece);
}

/* Modale Coffre */
if(coffreDemarrer){
    coffreDemarrer.addEventListener('click', function() {
        coffreContenu.classList.remove('display--none');
        coffreDemarrer.classList.add('display--none');
        transitionColor(coffreModale, "#000000", "#171219");
        grandir(coffreImg);
        coffreMusic.play();
        
        coffreMusic.addEventListener('ended', function () {
            coffreModale.classList.add('display--none');
            fadeIn(participantsForm);
            animateStagger(participantsInscription);
        });
    });
}

/* Modale premier */
function afficherPremier () {
    fadeIn(premierModale);
    const joueurAleatoire = participants[Math.floor(Math.random() * participants.length)];
    premierNom.textContent = joueurAleatoire.nom;
    assignerCouleurPremier(joueurAleatoire);
    setTimeout(() => {
        premierModale.classList.add('display--none');
        jeuSection.classList.remove('display--none');
        changerPierre();
        actualiserJoueurs();
    }, 5000);
}

function assignerCouleurPremier(joueur) {
    const couleurs = ["premier--jaune", "premier--rouge", "premier--bleu", "premier--vert"];
    const indexJoueur = participants.indexOf(joueur);
    const premierElement = document.querySelector(".premier");
    
    if (premierElement) {
        premierElement.classList.remove(...couleurs);
        premierElement.classList.add(couleurs[indexJoueur]);
    }
}

/* Modale Faveurs */
function afficherFaveurs() {
    const joueur = participants[joueurIndex];

    if(joueur.maudit || joueur.faveur != 0 || joueur.faveur == faveurRetiree){
        changerPierre();

        setTimeout(() => {
            pieceModale.classList.add('display--none');
        }, 10);
    } else {
        pieceModale.classList.add('display--none');
        boutiqueSound.play();
        faveursModale.classList.remove('display--none');
        animateStagger(faveursList);
        faveurBourse.textContent = joueur.bourse;
        faveurPseudo.textContent = joueur.nom;
        faveurPseudo.classList.remove(
            'jaune',
            'rouge',
            'bleu',
            'vert'
        );

        switch (joueurIndex) {
            case 0:
                faveurPseudo.classList.add('jaune');
                break;
            case 1:
                faveurPseudo.classList.add('rouge');
                break;
            case 2:
                faveurPseudo.classList.add('bleu');
                break;
            case 3:
                faveurPseudo.classList.add('vert');
                break;
        }
    }

    faveursAchetables(joueur);
}

function faveursAchetables(joueur) {
    faveursElement.forEach(el => {
        const valeurElement = el.querySelector('.faveurs__valeur');
        const bouton = el.querySelector('.faveurs__faveur');

        const valeur = parseInt(valeurElement.textContent, 10);

        if (valeur <= joueur.bourse && joueur.faveur == 0 && !bouton.classList.contains('faveurs__faveur--vendu')) {
            bouton.classList.remove('faveurs__faveur--indisponible');
            bouton.style.pointerEvents = 'auto';
        } else {
            bouton.classList.add('faveurs__faveur--indisponible');
            bouton.style.pointerEvents = 'none';
        }
    });
}

if (faveursButtons && faveursModale) {
    faveursButtons.forEach((button, index) => {
        button.addEventListener('click', function() {
            achatSound.play();
            const joueur = participants[joueurIndex];
            this.closest('.faveurs__faveur').classList.add('faveurs__faveur--vendu');
            joueur.faveur = index + 1;

            switch (joueurIndex) {
                case 0:
                    button.classList.add('jaune');
                    break;
                case 1:
                    button.classList.add('rouge');
                    break;
                case 2:
                    button.classList.add('bleu');
                    break;
                case 3:
                    button.classList.add('vert');
                    break;
            }

            faveursAchetables(joueur);

            achatSound.addEventListener('ended', () => {
                actualiserJoueurs();
                changerPierre();
                console.log(`Faveur donnée à ${joueur.nom}`, participants);

                setTimeout(() => {
                    faveursModale.classList.add('display--none');
                }, 10);
            }, { once: true });
        });
    });
}

function actualiserFaveurs(index, joueur) {
    const faveursAffichees = document.querySelectorAll('.joueurs__faveur');

    if(joueur.maudit || joueur.faveur == 0 || joueur.faveur == faveurRetiree){
        faveursAffichees[index].classList.add('display--none');
    } else {
        switch (joueur.faveur) {
            case 1:
                faveursAffichees[index].src = "/tfe-app/assets/images/pot-de-vin.webp";
                break;
            case 2:
                faveursAffichees[index].src = "/tfe-app/assets/images/immunite.webp";
                break;
            case 3:
                faveursAffichees[index].src = "/tfe-app/assets/images/damocles.webp";
                break;
            case 4:
                faveursAffichees[index].src = "/tfe-app/assets/images/echange.webp";
                break;
        }

        faveursAffichees[index].classList.remove('display--none');
    }
}

if (faveurConserver && faveursModale) {
    faveurConserver.addEventListener('click', function() {
        changerPierre();

        setTimeout(() => {
            faveursModale.classList.add('display--none');
        }, 10);
    });
}

/* Modale Paramètres */
function updateSoundSetting(parametres, soundObjects, storageKey, imageElement, offImage, onImage) {
    let isMuted = localStorage.getItem(storageKey) === 'true';

    soundObjects.forEach(sound => {
        sound.muted = isMuted;
    });

    imageElement.src = isMuted ? offImage : onImage;

    parametres.addEventListener('click', () => {
        fadeIn(parametres);
        isMuted = !isMuted;
        localStorage.setItem(storageKey, isMuted);

        soundObjects.forEach(sound => {
            sound.muted = isMuted;
        });

        imageElement.src = isMuted ? offImage : onImage;
    });
}

if (musiqueParametres) {
    updateSoundSetting(
        musiqueParametres,
        [backgroundMusic, coffreMusic, victoireJingle],
        'musicMuted',
        musiqueImgParametres,
        'assets/images/music-off.svg',
        'assets/images/music-on.svg'
    );
}

if (effetsParametres) {
    updateSoundSetting(
        effetsParametres,
        [touchSound, achatSound, maledictionSound, echangeSound, immuniteSound, epeeSound, victoireCris, boutiqueSound, spinCoinSound, staggerSound, pierreSound],
        'effetsMuted',
        effetsImgParametres,
        'assets/images/effects-off.svg',
        'assets/images/effects-on.svg'
    );
}

/* Sounds */
function sonPierreAleatoire() {
    pierreSound.pause();
    pierreSound.currentTime = 0;

    const numero = Math.floor(Math.random() * 5) + 1;
    pierreSound.src = `/tfe-app/assets/sons/pierre-${numero}.mp3`;

    setTimeout(() => {
        pierreSound.play().catch(e => {
            console.warn("Erreur lors de la lecture du son :", e);
        });
    }, 10);
}

/* Animations GSAP*/

/* Rotation Pièce */
function animatePieces(selector = ".spawn-piece") {
    const pieces = document.querySelectorAll(selector);

    if(damocles == false){
        spinCoinSound.play();
    }

    pieces.forEach(piece => {
        gsap.from(piece, {
            opacity: 0,
            scale: 0.5,
            rotationY: 90,
            duration: 0.5,
            ease: "back.out(1.7)"
        });

        gsap.to(piece, {
            rotationY: 720,
            duration: 2,
            ease: "power3.out"
        });
    });
}

/* Apparition Stagger */
function animateStagger(target) {
    if (target.classList.contains('joueurs__list') || target.classList.contains('participants__inscription')) {
        staggerSound.play();
    }
    gsap.fromTo(
        target.children,
        {
            opacity: 0,
            scale: 0.5,
        },
        {
            duration: 0.3,
            opacity: 1,
            scale: 1,
            stagger: 0.1,
            ease: "back.out(1.5)",
        }
    );
}

/* Levitation */
const levitations = document.querySelectorAll(".levitation");

levitations.forEach(levitation => {
    gsap.to(levitation, {
        scale: 1.05,
        duration: 1.5,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true
    });
});

/* Tremblement */
let animationSecousse = null;

function commencerSecousse(el) {
  if (animationSecousse) return;

  animationSecousse = gsap.to(el, {
    x: () => gsap.utils.random(-10, 10),
    y: () => gsap.utils.random(-10, 10),
    duration: 0.05,
    repeat: -1,
    yoyo: true
  });
}

function arreterSecousse(el) {
  if (animationSecousse) {
    animationSecousse.kill();
    gsap.set(el, { x: 0, y: 0 });
    animationSecousse = null;
  }
}

/* Fade-in */
function fadeIn(el) {
    el.classList.remove('display--none');
    gsap.fromTo(el, 
        { scale: 1.1, },
        { opacity: 1, scale: 1, duration: 0.4, }
    );
}

/* Fade-out */
function fadeOut(el) {
    el.classList.remove('display--none');

    gsap.to(el, {
        opacity: 0,
        scale: 0,
        duration: 0.5,
        ease: "power1.inOut",
        onComplete: () => {
            el.classList.add('display--none');
            gsap.set(el, { opacity: 1, scale: 1 });
        }
    });
}

/* Rotation */
let rotated = false;
function rotate(el) {
    gsap.to(el, {
        rotation: rotated ? 0 : 180,
        duration: 0.5,
        ease: "power1.inOut"
    });
    rotated = !rotated;
}

/* Cercle Paramètres */
let expanded = false;
let isAnimating = false;

function getDiagonalSize() {
  return Math.ceil(Math.sqrt(window.innerWidth ** 2 + window.innerHeight ** 2)) * 2;
}

function updateTailleCercle() {
    const size = getDiagonalSize();
    isAnimating = true;

    if (expanded) {
        gsap.to(cercleParametres, {
            width: size + 'px',
            height: size + 'px',
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: () => {
                menuParametres.classList.remove('display--none');
                animateStagger(menuParametres);
                isAnimating = false;
            }
        });
    } else {
        menuParametres.classList.add('display--none');
        gsap.to(cercleParametres, {
            width: '0px',
            height: '0px',
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: () => {
                isAnimating = false;
            }
        });
    }
}

if (toggleParametres) {
    toggleParametres.addEventListener('click', () => {
        if (isAnimating) return;

        rotate(toggleParametres);
        touchSound.play();
        expanded = !expanded;
        updateTailleCercle();
    });

    window.addEventListener('resize', () => {
        if (expanded && !isAnimating) updateTailleCercle();
    });
}

/* Texte Stagger */
const typingStagger = document.querySelector('.typing-stagger');

function startTypingStagger() {
    const duration = coffreMusic.duration;
    gsap.fromTo(
        typingStagger.children,
        {
            opacity: 0,
            scale: 0.5,
        },
        {
            duration: duration,
            opacity: 1,
            scale: 1,
            stagger: 0.2,
            ease: "power1.out",
        }
    );
}

if(coffreMusic){
    coffreMusic.addEventListener('play', () => {
        startTypingStagger();
    });
}

/* Grandir */
function grandir(el) {
    const duration = coffreMusic.duration;
    gsap.set(el, { opacity: 0, scale: 0.9 });
    gsap.to(el, {
        opacity: 1,
        scale: 1,
        duration: duration,
        ease: "power1.out"
    });
}

/* Background Color Coffre */
function transitionColor(el, startColor = "#000000", endColor = "#171219") {
    const duration = coffreMusic.duration;
    gsap.set(el, {
        backgroundColor: startColor
    });

    gsap.to(el, {
        backgroundColor: endColor,
        duration: duration,
        ease: "power1.out"
    });
}

/* Canvas Victoire */
if(victoireCanvas){
    const ctx = victoireCanvas.getContext('2d');

    let width = window.innerWidth;
    let height = window.innerHeight;
    victoireCanvas.width = width;
    victoireCanvas.height = height;

    const coinImage = new Image();
    coinImage.src = '/tfe-app/assets/images/pieceIcone.webp';

    const coins = [];

    function random(min, max) {
        return Math.random() * (max - min) + min;
    }

    class Coin {
        constructor() {
            this.reset();
        }

        reset() {
            this.size = random(30, 63);
            this.speed = (this.size - 30) / (50 - 30) * (4 - 1) + 1;
            this.x = random(0, width);
            this.y = random(-height, 0);
        }

        update() {
            this.y += this.speed;
            if (this.y > height) this.reset();
        }

        draw() {
            ctx.drawImage(coinImage, this.x - this.size / 2, this.y - this.size / 2, this.size, this.size);
        }
    }

    function initCoins() {
        coins.length = 0;
        const count = Math.floor(width / 30);
        for (let i = 0; i < count; i++) {
            coins.push(new Coin());
        }
    }

    function animate() {
        ctx.clearRect(0, 0, width, height);

        coins.sort((a, b) => a.size - b.size);

        coins.forEach((coin) => {
            coin.update();
            coin.draw();
        });

        ctx.globalAlpha = 0.7;
        ctx.fillStyle = '#171219';
        ctx.fillRect(0, 0, width, height);
        ctx.globalAlpha = 1;

        requestAnimationFrame(animate);
    }

    window.addEventListener('resize', () => {
        width = window.innerWidth;
        height = window.innerHeight;
        victoireCanvas.width = width;
        victoireCanvas.height = height;
        initCoins();
    });

    coinImage.onload = () => {
        initCoins();
        animate();
    };
}